// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__modHR","additionalInfo":"AgreementModal_additionalInfo__1U6_f"};